export function isRequesting(state) {
  return state.pairingRequester.isRequesting;
}
export function getRequest(state) {
  return state.pairingRequester.request;
}
export function getResponder(state) {
  return state.pairingRequester.responder;
}
export function getPairingSource(state) {
  return state.pairingRequester.pairingSource;
}

export function getResponderDeviceName(state) {
  return state.pairingRequester.responder?.name;
}
export function getResponderId(state) {
  return state.pairingRequester.responder?.id;
}
export function getError(state) {
  return state.pairingRequester.error;
}
export function getResponse(state) {
  return state.pairingRequester.response;
}
export function getResponderFamilyName(state) {
  return state.pairingRequester.response?.familyName;
}
